import EditProfileScreen from "@/src/screens/profile/edit-profile";

export default function EditProfile() {
  return <EditProfileScreen />;
}
